import uuid from 'js-uuid';
import { useRef } from 'react';

export function useEngagementSession(feature) {
  const sessionId = useRef(uuid.v1());
  const func = useRef((event, callback) => {
    return n => {
      if (window.AhaAnalytics) {
        window.AhaAnalytics.track(feature, event, {
          t: Date.now(),
          n: n,
          searchSessionId: sessionId.current,
          v: window.featureFlags.enhanced_search ? 'e' : 'c',
        });
      }

      if (callback !== null && typeof callback === 'function') {
        return callback(n);
      }
    };
  });

  return func.current;
}
